<template>
  <section>
    <div class="">
      <section class="relative">
        <div class="flex flex-col md:flex-row">
          <div v-if="src != ''">
            <img
              :src="src"
              alt=""
              class="rounded-lg object-cover"
              style=""
              @error="defaultImage"
            />
            <!-- <button
              title="Edit Thumbnail"
              @click="handleClick"
              v-if="
                (batches && batches.length == 0) ||
                (batches && batches.length == null)
              "
            >
              <Pencil
                class="absolute top-0 right-0 mr-36 mt-3 p-1 hover:bg-blue-lightest text-gray-dark rounded-lg bg-white ring-1 ring-gray-300"
              />
            </button>
            <button title="Edit Thumbnail is currently disabled." v-else>
              <Pencil
                class="absolute top-0 right-0 mr-36 mt-3 p-1 hover:bg-blue-light text-indigo-100 rounded-lg bg-gray-100 ring-1 ring-gray-300"
              />
            </button> -->
            <!-- bg-white -->
            <div
              class="absolute bottom-0 p-6 rounded-lg space-x-2 md:m-6 md:mb-12 my-24 w-full max-w-md"
              style="opacity: 0.9"
            >
              <div class="flex items-center justify-between">
                <!-- <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-green-light"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path
                      fill-rule="evenodd"
                      d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <p class="text-sm">
                    <span class="text-green-light">0</span>
                    students are watching this video
                  </p>
                </div> -->
                <button
                  type="button"
                  class="h-8 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                  v-if="$route.name == 'UserSessionLive'"
                >
                  Join Class
                </button>
                <div v-else>
                  <router-link
                    class="h-8 py-1 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                    :to="{
                      name: 'UserSessionLive',
                      params: { id: course_groups.zoom_meeting.batch_id },
                    }"
                    v-if="course_groups && course_groups.zoom_meeting"
                  >
                    Join Class
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <img
            v-else
            :src="src"
            alt=""
            class="rounded-lg object-cover"
            style="width: 800px; height: 450px"
            @error="defaultImage"
          />
          <section v-if="src != ''" class="md:w-2/12 w-auto mb-4 md:mb-0">
            <div class="md:pl-3 pl-0">
              <div>
                <section class="flex gap-4 md:flex-col flex-row mt-4 md:mt-0">
                  <div v-for="(d, i) in supportingImages" :key="d.id">
                    <div class="">
                      <img
                        class="object-cover rounded-lg max-width-image"
                        v-bind:class="{
                          'rounded-tr-lg': i == 1,
                          'rounded-br-lg': i == 3,
                        }"
                        :src="baseUrlSrc(d.thumbnail_url)"
                        alt="..."
                        @error="defaultImage"
                      />
                    </div>
                  </div>
                </section>
              </div>

              <div
                v-for="d in supportingImages"
                :key="d.id"
                class="flex hidden max-w-xs overflow-auto"
              >
                <div class="p-1">
                  <img
                    class="object-cover max-w-none ring-1 ring-gray-300 max-width-image rounded"
                    :src="baseUrlSrc(d.thumbnail_url)"
                    alt=""
                    @error="defaultImage"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <section v-if="sessionDetails">
        <div class="grid mt-3 md:grid-cols-6 grid-cols-2 gap-4">
          <div class="bg-gray-lighter rounded-lg p-4">
            <svg
              class="mx-auto"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="18"
                y="0.000244141"
                width="6"
                height="24"
                rx="1.26087"
                fill="#C4C4C4"
              />
              <rect
                x="8.99951"
                y="6.00024"
                width="6"
                height="18"
                rx="1.26087"
                fill="#C4C4C4"
              />
              <rect y="12" width="6" height="12" rx="1.26087" fill="#8DC73F" />
            </svg>

            <p class="text-gray-light text-xs mt-1">
              {{ course && course.details && course.details.difficulty_type }}
              level
            </p>
          </div>
          <div class="bg-gray-lighter rounded-lg p-4">
            <p class="font-semibold">
              {{ course && course.details && course.details.language_name }}
            </p>
            <span class="text-gray-light text-xs">Language</span>
          </div>
          <div class="bg-gray-lighter rounded-lg p-4">
            <p class="font-bold">
              {{ sessionsDuration() }}
              <!-- {{
                course &&
                course.details &&
                minToHourMin(course.details.duration)[0]
              }}
              <span class="text-gray-light text-xs">hr</span>
              {{
                course &&
                course.details &&
                minToHourMin(course.details.duration)[1]
              }}
              <span class="text-gray-light text-xs">mins</span> -->
            </p>
            <span class="text-gray-light text-xs">Total Duration</span>
          </div>
          <div class="bg-gray-lighter rounded-lg p-4">
            <p class="font-bold">
              {{ (course && course.total_count) || "0" }}
            </p>
            <span class="text-gray-light text-xs">Students</span>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import { Pencil } from "@/components/icons";

export default {
  name: "SessionDetailsThumbnail",
  components: {
    Pencil,
  },
  props: {
    src: String,
    supportingImages: Array,
    sessions: {
      type: Array,
    },
    course: Object,
    sessionDetails: {
      type: Boolean,
      default: true,
    },
    entityType: Number,
    course_groups: {
      type: Object,
    },
    // batches: {
    //   type: Array,
    // },
  },
  data() {
    return {
      id: "",
    };
  },
  methods: {
    // handleClick() {
    //   this.id = this.$route.params.id;
    //   if (this.entityType === 2) {
    //     this.$router.push({
    //       name: "CourseEdit",
    //       query: { step: 2 },
    //     });
    //   }
    //   if (this.entityType === 1) {
    //     this.$router.push({
    //       name: "createSession",
    //       query: { step: 2 },
    //       params: { id: `${this.id}` },
    //     });
    //   }
    // },

    sessionsDuration() {
      let durationSum = 0;
      this.sessions &&
        this.sessions.forEach(
          (el) => (durationSum = durationSum + el.duration)
        );
      return `${this.minToHourMin(durationSum)[0]}hr ${
        this.minToHourMin(durationSum)[1]
      }mins`;
    },
  },
};
</script>
<style lang="scss" scoped>
  .max-width-image{
    max-width: 100px;
  }

</style>